import type { CSSProperties } from 'react';
import { Toaster as SonnerToaster, toast } from 'sonner';
import { useTheme } from '../lib/theme';

/**
 * Variáveis do sonner apontando para os tokens: o toast segue o tema claro/escuro sozinho.
 * Toasts neutros (superfície elevada) com ícone colorido por tipo; texto sempre >= 4,5:1.
 */
const TOKENS = {
  '--normal-bg': 'var(--color-elevated)',
  '--normal-bg-hover': 'var(--color-surface-2)',
  '--normal-border': 'var(--color-line)',
  '--normal-border-hover': 'var(--color-line-strong)',
  '--normal-text': 'var(--color-ink)',
  '--success-bg': 'var(--color-elevated)',
  '--success-border': 'var(--color-line)',
  '--success-text': 'var(--color-ink)',
  '--info-bg': 'var(--color-elevated)',
  '--info-border': 'var(--color-line)',
  '--info-text': 'var(--color-ink)',
  '--warning-bg': 'var(--color-elevated)',
  '--warning-border': 'var(--color-line)',
  '--warning-text': 'var(--color-ink)',
  '--error-bg': 'var(--color-elevated)',
  '--error-border': 'var(--color-line)',
  '--error-text': 'var(--color-ink)',
  '--border-radius': '14px',
} as CSSProperties;

/** Toasts no topo (celular) ou canto (desktop), no padrão visual do app. */
export function Toaster({ position = 'top-center' }: { position?: 'top-center' | 'top-right' | 'bottom-right' | 'bottom-center' }) {
  const { resolvedTheme } = useTheme();
  return (
    <SonnerToaster
      position={position}
      theme={resolvedTheme}
      richColors
      closeButton
      duration={4000}
      style={TOKENS}
      toastOptions={{
        classNames: {
          toast: 'font-sans text-[15px] shadow-pop! gap-2.5!',
          title: 'font-semibold tracking-[-0.01em]',
          description: 'text-ink-2! text-[13.5px]',
          icon: 'self-start mt-px',
          success: '[&_[data-icon]]:text-success',
          error: '[&_[data-icon]]:text-danger',
          warning: '[&_[data-icon]]:text-warning',
          info: '[&_[data-icon]]:text-info',
          actionButton: 'bg-primary! text-on-primary! rounded-lg! font-semibold! px-3! h-8!',
          cancelButton: 'bg-ink/[0.06]! text-ink! rounded-lg! h-8!',
          closeButton: 'bg-elevated! border-line! text-ink-3! hover:text-ink!',
        },
      }}
    />
  );
}

export { toast };
